import axios from "axios"
import type {AxiosResponse, AxiosRequestConfig, Method} from "axios"

export class ApiBase {
    private static backendUrl = ""
    public static KEY = "616797a6d992dba4c42e3277847fcc7b5fd91713"

    public static init(url: string) {
        this.backendUrl = url
    }

    /*
        Generic api method
    */
    protected static async doApiCall(method: Method, endPoint: string, data: object | null = null, extraOptions: object | null = null): Promise<any> {
        if (this.backendUrl === "") {
            console.log("api init not called")
            return
        }

        const url = this.backendUrl + endPoint

        const headers = {
            "X-Auth": this.KEY,
            "Content-Type": "application/json"
        }

        const config: AxiosRequestConfig = {
            method,
            headers,
            url,
            data
        }

        if (extraOptions !== null) {
            Object.assign(config, extraOptions)
        }

        try {
            const response: AxiosResponse<object> = await axios(config)
            return response.data
        } catch (error) {
            console.log("doApiCall error", error)
            throw error
        }
    }
}
